import { getAuth } from "firebase/auth";

import { USER_PLAN_QUERY_KEY } from "@/components/Root/hooks/useUserPlanData";
import { queryClient } from "@/lib/router/instances";
import { TCustomerIOTraits } from "@/services/customerio";
import { TUserPlanData } from "@/types/plan-data";

const NOT_SIGNED = "not signed";

/** Injected into initializeCustomerIO; keeps the query client out of the service layer. */
export const buildCustomerIOEventContext = (): TCustomerIOTraits => {
  const user = getAuth().currentUser;
  const plan = queryClient.getQueryData<TUserPlanData>([USER_PLAN_QUERY_KEY]);

  return {
    email: user?.email ?? NOT_SIGNED,
    uid: user?.uid,
    plan_name: plan?.planName,
    plan_interval: plan?.recurring?.interval,
    plan_status: plan?.status,
    product_id: plan?.product_id,
  };
};
